/*
  Cambia la variante de una línea del carrito desde un <select> inline.

  Flujo cuando el cliente cambia un dropdown (Color, Talla, etc.):
    1. Lee todas las selecciones actuales de los selects de esa línea
    2. Busca la variante que coincide en el JSON embedido
    3. Si no existe o está agotada → alerta y revierte el select
    4. Si existe → /cart/change.js con quantity 0 (borra la línea) y luego
       /cart/add.js para añadir la nueva variante con la misma cantidad
    5. Refresca el carrito (drawer o /cart) llamando theme.cart.buildCart()
*/
(function () {
  var pending = false;

  function getCartItemEl(target) {
    return target.closest('.cart__item');
  }

  function getVariants(itemEl) {
    var script = itemEl.querySelector('script.cart__variant-data');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('cart-variant-switcher: JSON parse error', e);
      return null;
    }
  }

  function getCurrentSelections(itemEl) {
    var selects = itemEl.querySelectorAll('select.cart__variant-select');
    return Array.prototype.map.call(selects, function (s) { return s.value; });
  }

  function findVariant(variants, selectedOptions) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < v.options.length; j++) {
        if (v.options[j] !== selectedOptions[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function getCurrentQuantity(itemEl) {
    var qtyInput = itemEl.querySelector('input[name="updates[]"]');
    return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
  }

  function setItemDisabled(itemEl, disabled) {
    var selects = itemEl.querySelectorAll('select.cart__variant-select');
    Array.prototype.forEach.call(selects, function (s) { s.disabled = disabled; });
    itemEl.classList.toggle('is-updating', disabled);
  }

  async function changeVariant(itemEl, newVariantId, qty) {
    var oldKey = itemEl.dataset.key;
    if (!oldKey) throw new Error('Cart item missing data-key');

    // 1. Eliminar la línea antigua
    var removeResp = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: oldKey, quantity: 0 })
    });
    if (!removeResp.ok) throw new Error('Failed to remove old line: ' + removeResp.status);

    // 2. Añadir la nueva variante
    var addResp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: newVariantId, quantity: qty })
    });
    if (!addResp.ok) {
      var msg = 'No se ha podido añadir la nueva variante.';
      try {
        var err = await addResp.json();
        if (err && err.description) msg = err.description;
      } catch (e) {}
      throw new Error(msg);
    }
  }

  function refreshCart() {
    // El theme Impulse escucha "cart:build" para re-renderizar el drawer
    // y la página /cart sin recargar (theme.js:1698).
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  async function handleChange(e) {
    var select = e.target;
    if (!select.matches('select.cart__variant-select')) return;
    if (pending) return;

    var itemEl = getCartItemEl(select);
    if (!itemEl) return;

    var variants = getVariants(itemEl);
    if (!variants) return;

    var selectedOptions = getCurrentSelections(itemEl);
    var newVariant = findVariant(variants, selectedOptions);

    if (!newVariant) {
      alert('Esa combinación no está disponible.');
      refreshCart();
      return;
    }
    if (!newVariant.available) {
      alert('Esa combinación está agotada.');
      refreshCart();
      return;
    }

    pending = true;
    setItemDisabled(itemEl, true);

    try {
      var qty = getCurrentQuantity(itemEl);
      await changeVariant(itemEl, newVariant.id, qty);
      refreshCart();
    } catch (err) {
      console.error('cart-variant-switcher:', err);
      alert(err.message || 'Error al cambiar la variante.');
      refreshCart();
    } finally {
      pending = false;
    }
  }

  document.addEventListener('change', handleChange);
})();
